import { Injectable } from '@angular/core';

import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoJsService {
  private cipherKey: string = '5182d8f8-e5f3-11e8-9f32-f2801f1b9fd1';

  constructor() { }

  encryptText(text: string) {
    return CryptoJS.AES.encrypt(text, this.cipherKey).toString();
  }

  dencryptText(text: string) {
    const bytes = CryptoJS.AES.decrypt(text, this.cipherKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  encryptObject(object: any) {
    return CryptoJS.AES.encrypt(JSON.stringify(object), this.cipherKey).toString();
  }

  dencryptObject(object: any) {
    const bytes = CryptoJS.AES.decrypt(object, this.cipherKey);

    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
}
